import { DISPLAY_CLASSES, customTV } from '../../utils/tailwind';
export const logo = customTV({
    base: '[&_svg]:size-inherit svg-children:fill-content-default dark:svg-children:fill-content-default-dark',
    variants: {
        display: DISPLAY_CLASSES,
        inverted: {
            true: 'svg-children:fill-white-100 dark:svg-children:fill-content-default [&_svg]:drop-shadow-[0_2px_10px_rgba(0,0,0,0.3)]',
        },
        customHeight: {
            true: '[&_svg]:h-[--logo-height] [&_svg]:w-[--logo-width]',
        },
    },
});
